export default __webpack_public_path__ + "static/media/house-14.d167029f.jpg";